"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomProvider = exports.CustomProviderBase = void 0;
var ethers_1 = require("ethers");
var logger_1 = require("@ethersproject/logger");
var utils_1 = require("ethers/lib/utils");
var utils_2 = require("./utils");
// class CustomLogger extends Logger {
//   throwError(
//     message: string,
//     code?: ethers.errors | undefined,
//     params?: any
//   ): never {
//     try {
//       super.throwError(message, code, params);
//     } catch (error) {
//       throw parseEthersJsError(error);
//     }
//   }
// }
var logger = new logger_1.Logger(ethers_1.version);
var CustomProviderBase = /** @class */ (function (_super) {
    __extends(CustomProviderBase, _super);
    function CustomProviderBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomProviderBase.prototype.resolveName = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resolveAddress(name)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomProviderBase.prototype.lookupAddress = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resolveUsername(address)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomProviderBase.prototype.resolveAddress = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            var transaction, addr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, name];
                    case 1:
                        name = _a.sent();
                        // If it is already an address, nothing to resolve
                        try {
                            return [2 /*return*/, Promise.resolve(this.formatter.address(name))];
                        }
                        catch (error) {
                            // If is is a hexstring, the address is bad (See #694)
                            if (utils_1.isHexString(name)) {
                                throw error;
                            }
                        }
                        if (typeof name !== 'string') {
                            logger.throwArgumentError('invalid ENS name', 'name', name);
                        }
                        if (!this.network.ensAddress) {
                            logger.throwError('ens address is not configured');
                        }
                        transaction = {
                            to: this.network.ensAddress,
                            data: '0x6a14920a' + ethers_1.ethers.utils.formatBytes32String(name).substring(2),
                        };
                        return [4 /*yield*/, this.call(transaction)];
                    case 2:
                        addr = _a.sent();
                        if (addr.length > 42) {
                            addr = utils_1.hexZeroPad(utils_1.hexStripZeros(addr), 20);
                        }
                        if (addr === ethers_1.ethers.constants.AddressZero) {
                            logger.throwError("The kycname " + name + " does not resolve to a non-zero address");
                        }
                        return [2 /*return*/, this.formatter.address(addr)];
                }
            });
        });
    };
    CustomProviderBase.prototype.resolveUsername = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var name, _a, addr;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, address];
                    case 1:
                        address = _b.sent();
                        address = this.formatter.address(address);
                        _a = utils_1.parseBytes32String;
                        return [4 /*yield*/, this.call({
                                to: this.network.ensAddress,
                                data: '0x1f70693c' + ethers_1.ethers.utils.hexZeroPad(address, 32).substring(2),
                            })];
                    case 2:
                        name = _a.apply(void 0, [_b.sent()]);
                        if (name === '') {
                            logger.throwError("The address " + address + " does not resolve to a non-empty username");
                        }
                        return [4 /*yield*/, this.resolveName(name)];
                    case 3:
                        addr = _b.sent();
                        if (addr != address) {
                            logger.throwError("The address " + address + " mismatches with the resolved address of " + name + " as " + addr);
                        }
                        return [2 /*return*/, name];
                }
            });
        });
    };
    CustomProviderBase.prototype.call = function (transaction, blockTag
    // @ts-ignore Because including undefined makes the override  signature mismatch
    ) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var resp, error_1, data, actualData, iface;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, _super.prototype.call.call(this, transaction, blockTag)];
                    case 1:
                        resp = _b.sent();
                        // console.log(resp);
                        return [2 /*return*/, resp];
                    case 2:
                        error_1 = _b.sent();
                        data = (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.error) === null || _a === void 0 ? void 0 : _a.data;
                        // console.log('resp', data);
                        if (typeof data === 'string' && data.slice(0, 9) === 'Reverted ') {
                            actualData = data.slice(9);
                            iface = new ethers_1.ethers.utils.Interface(['function Error(string)']);
                            logger.throwError(actualData !== '0x'
                                ? iface.decodeFunctionData('Error', actualData)[0]
                                : 'Call was reverted without a revert reason', logger_1.Logger.errors.CALL_EXCEPTION);
                        }
                        else {
                            throw error_1;
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomProviderBase.prototype.estimateGas = function (transaction) {
        return __awaiter(this, void 0, void 0, function () {
            var resp, error_2, from, to, data, value, provider, result, _a, _b, _c, error_3, i;
            var _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 2, , 9]);
                        return [4 /*yield*/, _super.prototype.estimateGas.call(this, transaction)];
                    case 1:
                        resp = _e.sent();
                        // console.log(resp);
                        return [2 /*return*/, resp];
                    case 2:
                        error_2 = _e.sent();
                        from = transaction.from, to = transaction.to, data = transaction.data, value = transaction.value;
                        // @ts-ignore
                        if (typeof value === 'object' && value._isBigNumber) {
                            // @ts-ignore
                            value = value.toHexString();
                        }
                        provider = this;
                        if (!provider.send) return [3 /*break*/, 8];
                        result = void 0;
                        _e.label = 3;
                    case 3:
                        _e.trys.push([3, 6, , 7]);
                        _b = (_a = provider).send;
                        _c = ['trace_call'];
                        _d = { from: from };
                        return [4 /*yield*/, to];
                    case 4: return [4 /*yield*/, _b.apply(_a, _c.concat([[
                                (_d.to = _e.sent(), _d.data = data, _d.value = value, _d),
                                ['vmtrace', 'trace']
                            ]]))];
                    case 5:
                        result = _e.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        error_3 = _e.sent();
                        console.log('trace_call error:', utils_2.parseEthersJsError(error_3));
                        return [3 /*break*/, 7];
                    case 7:
                        if (result === null || result === void 0 ? void 0 : result.output) {
                            i = new ethers_1.ethers.utils.Interface(['function Error(string)']);
                            return [2 /*return*/, logger.throwError((result === null || result === void 0 ? void 0 : result.output) !== '0x'
                                    ? i.decodeFunctionData('Error', result.output)[0]
                                    : 'Call was reverted without a revert reason', logger_1.Logger.errors.CALL_EXCEPTION)];
                        }
                        _e.label = 8;
                    case 8: return [2 /*return*/, logger.throwError('cannot estimate gas; transaction may fail or may require manual gas limit', logger_1.Logger.errors.UNPREDICTABLE_GAS_LIMIT, {
                            error: error_2,
                            tx: transaction,
                        })];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    return CustomProviderBase;
}(ethers_1.ethers.providers.StaticJsonRpcProvider));
exports.CustomProviderBase = CustomProviderBase;
var addresses_1 = require("./addresses");
var CustomProvider = /** @class */ (function (_super) {
    __extends(CustomProvider, _super);
    function CustomProvider(network) {
        var _this = this;
        switch (network) {
            case 'mainnet':
                _this = _super.call(this, 'https://mainnet.eraswap.network', {
                    name: 'EraSwapNetwork',
                    chainId: 5197,
                    ensAddress: addresses_1.addresses['production'].ESN.kycdapp,
                }) || this;
                break;
            case 'testnet':
                _this = _super.call(this, 'https://testnet.eraswap.network', {
                    name: 'EraSwapNetwork',
                    chainId: 5196,
                    ensAddress: addresses_1.addresses['development'].ESN.kycdapp,
                }) || this;
                break;
            default:
                throw new Error("CustomProvider needs 'mainnet' or 'testnet' as constructor arg");
        }
        return _this;
    }
    return CustomProvider;
}(CustomProviderBase));
exports.CustomProvider = CustomProvider;
//# sourceMappingURL=custom-provider.js.map